import { useMemo } from "react";
// 과세용 & 가상계좌 있음
const TAXABLE_WITH_VIRTUAL_ACCOUNT = process.env.NEXT_PUBLIC_TOSS_TAXABLE_WITH_VIRTUAL_ACCOUNT;
// 과세용 & 가상계좌 없음
const TAXABLE_WITHOUT_VIRTUAL_ACCOUNT = process.env.NEXT_PUBLIC_TOSS_TAXABLE_WITHOUT_VIRTUAL_ACCOUNT;
// 면세용 & 가상계좌 없음
const TAX_FREE_WITHOUT_VIRTUAL_ACCOUNT = process.env.NEXT_PUBLIC_TOSS_TAX_FREE_WITHOUT_VIRTUAL_ACCOUNT;
// 충전용 & 가상계좌 없음
const RECHARGE_WITHOUT_VIRTUAL_ACCOUNT = process.env.NEXT_PUBLIC_TOSS_RECHARGE_WITHOUT_VIRTUAL_ACCOUNT;
// 주문 타입과 조건에 따른 variant key 결정 함수
const getVariantKeyByOrderType = (orderType, price, isPassAmountType)=>{
    switch(orderType){
        case "pass":
        case "cash":
            if (isPassAmountType || orderType === "cash") {
                return RECHARGE_WITHOUT_VIRTUAL_ACCOUNT;
            } else {
                return price >= 10000 ? TAXABLE_WITH_VIRTUAL_ACCOUNT : TAXABLE_WITHOUT_VIRTUAL_ACCOUNT;
            }
        case "package":
        case "upgrade":
        case "separate":
        case "delivery":
            return price >= 10000 ? TAXABLE_WITH_VIRTUAL_ACCOUNT : TAXABLE_WITHOUT_VIRTUAL_ACCOUNT;
        case "pod":
            return price >= 100000 ? TAXABLE_WITH_VIRTUAL_ACCOUNT : TAXABLE_WITHOUT_VIRTUAL_ACCOUNT;
        case "ebook":
            return TAX_FREE_WITHOUT_VIRTUAL_ACCOUNT;
        default:
            return "DEFAULT";
    }
};
/**
 * amount에 따라 variantKey를 계산하는 훅
 *
 * amount와 "같은 렌더"에서 동기적으로 계산한다. useState + useEffect 방식은
 * amount 변경이 다음 렌더에서야 variantKey에 반영되어 한 박자 어긋났고,
 * 그 틈에 금액 갱신과 재렌더가 경쟁했다.
 */ export const useVariantKeyManager = (param)=>{
    let { orderType , amount , isPassAmountType , packageVariantKey  } = param;
    const variantKey = useMemo(()=>{
        if (orderType === "package") {
            return packageVariantKey || getVariantKeyByOrderType(orderType, amount);
        }
        return getVariantKeyByOrderType(orderType, amount, isPassAmountType);
    }, [
        orderType,
        amount,
        isPassAmountType,
        packageVariantKey
    ]);
    return {
        variantKey
    };
};
